import api from "lib/api";

export const getNotificationList = async (params) =>
    await api.post("/v1/emailTemplate/getNotificationList", params);

export const saveNotification = async (params) =>
    await api.post("/v1/emailTemplate/saveNotification", params);

export const deleteNotification = async (params) =>
    await api.post("/v1/emailTemplate/deleteNotification", params);

export const getEmailTemplateList = async (params) =>
    await api.post("/v1/emailTemplate/getEmailTemplateList", params);

export const getEmailLoopList = async (params) =>
    await api.post("/v1/emailTemplate/getEmailLoopList", params);